import React from "react";
import "./contact.css";
import ContactForm from "../../components/ContactForm";

const Contact = () => {
    return (
      <>
      <div className="contact-section">
        
      </div>

      <ContactForm/>
      </>
    );
  };
  
export default Contact;

